export default theme => ({
  aggregatedInformation: {
    margin: theme.spacing(1),
  }
});